import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getOrderDetails,getGeofenceByFleetId, getFleetConfigByFleetId } from "../API";
import {findNorthWestAndSouthEast} from "../utils"
import Header from "./Header";
import PinVerificationModal from "./reusable/PinVerificationModal";
import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import Footer from "./Footer";

function OrderPickedUp() {
  const { orderID } = useParams();
  const [orderDetails, setOrderDetails] = useState();
  const [expectedPin, setExpectedPin] = useState(null);
  const [pinVerified, setPinVerified] = useState(false);

  const loaderContainerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "10vh",
  };

  const loaderStyle = {
    border: "4px solid rgba(0, 0, 0, 0.1)",
    borderTop: "4px solid #000",
    borderRadius: "50%",
    width: "40px",
    height: "40px",
    animation: "spin 1s linear infinite",
  };

  const keyframesAnimation = `
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `;

  useEffect(() => {
    getOrderDetails(orderID)
      .then((res) => {
        const data = res?.data?.data;
        const pinVal = data?.pin;
        if (pinVal != null && String(pinVal).trim() !== "") {
          setExpectedPin(String(pinVal).trim());
        }
        getGeofenceByFleetId(data?.fleetId).then((res)=>{
          const maxBoundCordinates = findNorthWestAndSouthEast(res.data.geofence)
          console.log(maxBoundCordinates)        })
        setOrderDetails(data);
      })
      .catch((err) => {
        console.log("Error ", err);
      });
  }, [orderID]);
  useEffect (() => {
    const fetchFleetConfig = async () => {
      try {
        const response = await getFleetConfigByFleetId(process.env.REACT_APP_FLEETID);
        const data = response?.data?.data
        localStorage.setItem("fleetConfig", JSON.stringify(data));
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchFleetConfig();
  },[orderID])

  const formattedDate = (date) => {
    const orderDate = new Date(date);
    const yyyy = orderDate.getFullYear();
    let mm = orderDate.getMonth() + 1; // Months start at 0!
    let dd = orderDate.getDate();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    return mm + "-" + dd + "-" + yyyy;
  };

  const pinRequired = expectedPin != null && expectedPin !== "";
  const showContent = !pinRequired || pinVerified;

  return (
    <>
      <PinVerificationModal
        open={pinRequired && !pinVerified}
        expectedPin={expectedPin}
        onVerified={() => setPinVerified(true)}
      />
      {showContent && (
      <div className="MainWhole-wrapper-container">
        <Header />
        <div className="overflow-auto h-[calc(100vh-11rem)]">
          <div className="bg-primary h-[22vh] text-white text-center">
            <h3 className="text-[23px] pt-6 font-bold">
              {" "}
              Your Order was Picked Up.
            </h3>
          </div>
          <div className="bg-white rounded-full mx-auto w-[120px] h-[120px] -mt-[66px] flex justify-center mb-5">
            <img className="w-[72px]" src="/assets/images/noun-tick-317777.svg" alt="" />
          </div>
          <div>
            <h3 className="text-primary font-extrabold text-[27px]"> Order Picked Up</h3>
          </div>
          <Timeline position="alternate" style={{ marginTop: "0px" }}>
            <TimelineItem>
              <TimelineSeparator>
                <TimelineDot variant="outlined" className="!bg-primary !border-primary" />
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent></TimelineContent>
            </TimelineItem>
            <div className="text-center pb-5">
              <h4 className="font-extrabold text-[19px]">Order ID </h4>
              <p className="text-primary text-[20px] font-semibold"> {orderID}</p>
            </div>
            <TimelineItem>
              <TimelineSeparator>
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent></TimelineContent>
            </TimelineItem>
            <div className="mb-20 text-center pb-5">
              <h4 className="font-extrabold text-[19px]">Date </h4>
              {orderDetails ? (
                <p className="text-primary text-[20px] font-semibold">{formattedDate(orderDetails?.createdAt)}</p>
              ) : (
                <div style={loaderContainerStyle}>
                  <style>{keyframesAnimation}</style>
                  <div style={loaderStyle}></div>
                </div>
              )}
            </div>
          </Timeline>
        </div>
      </div>
      )}
      {showContent && <Footer orderdelivered={true} />}
    </>
  );
}

export default OrderPickedUp;
